export class GenericPopupEvents {
    public static readonly INTRO_STARTED: symbol = Symbol('INTRO_STARTED');
    public static readonly INTRO_ANIMATION_STARTED: symbol = Symbol('INTRO_ANIMATION_STARTED');
    /**
     * use 'General.Popup.SHOW'
     * @deprecated
     */
    public static readonly SHOW_POPUP: symbol = Symbol('SHOW_POPUP');
    public static readonly FADE_OUT_STARTED: symbol = Symbol('FADE_OUT_STARTED');
    public static readonly POPUP_CLOSED: symbol = Symbol('POPUP_CLOSED');
    public static readonly POPUP_BUTTON_CLICKED: symbol = Symbol('POPUP_BUTTON_CLICKED');
}
